"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.coordinatesArrayBounded = exports.objectFromCoordinatesArray = exports.latLngLiteralFromCoordinatesArray = exports.coordinatesArrayFromObject = exports.coordinatesArrayFromLatLngLiteral = exports.COORDINATES_ARRAY_ATLANTA = exports.coordinatesArrayDescription = exports.coordinatesArraysDeserialize = exports.coordinatesArrayDeserialize = void 0;
const find_1 = __importDefault(require("lodash/find"));
const InvalidResult_1 = __importDefault(require("../type-descriptions/InvalidResult"));
const deserializeArray_1 = __importDefault(require("./deserializeArray"));
const deserializeLatitude_1 = __importDefault(require("./deserializeLatitude"));
const deserializeLongitude_1 = __importDefault(require("./deserializeLongitude"));
function coordinatesArrayDeserialize(value) {
    if (!Array.isArray(value))
        throw new Error(`Value "${value}" must be an array`);
    if (value.length !== 2)
        throw new Error(`Value "${value}" must have two elements`);
    if ((0, find_1.default)(value, isNaN))
        throw new Error(`Value "${value}" must be an array of numbers`);
    return [(0, deserializeLatitude_1.default)(value[0]), (0, deserializeLongitude_1.default)(value[1])];
}
exports.coordinatesArrayDeserialize = coordinatesArrayDeserialize;
exports.coordinatesArraysDeserialize = (0, deserializeArray_1.default)(coordinatesArrayDeserialize);
exports.coordinatesArrayDescription = {
    userFacingTitle: 'coordinates',
    userFacingValue: value => value.join(', '),
    validate: function (value) {
        if (!Array.isArray(value)) {
            return new InvalidResult_1.default('Not an array');
        }
        if (value.length !== 2) {
            return new InvalidResult_1.default(`Array must have two elements, but has ${value.length}`);
        }
        for (let i = 0; i < value.length; i++) {
            const element = value[i];
            if (typeof element !== 'number') {
                return new InvalidResult_1.default(`Element ${i} is not a number: ${element}`);
            }
        }
        return value;
    },
};
exports.COORDINATES_ARRAY_ATLANTA = [33.7557707, -84.3884782];
function coordinatesArrayFromLatLngLiteral(latLngLiteral) {
    return [latLngLiteral.lat, latLngLiteral.lng];
}
exports.coordinatesArrayFromLatLngLiteral = coordinatesArrayFromLatLngLiteral;
function coordinatesArrayFromObject(object) {
    return [object.latitude, object.longitude];
}
exports.coordinatesArrayFromObject = coordinatesArrayFromObject;
function latLngLiteralFromCoordinatesArray(array) {
    return { lat: array[0], lng: array[1] };
}
exports.latLngLiteralFromCoordinatesArray = latLngLiteralFromCoordinatesArray;
function objectFromCoordinatesArray(array) {
    return { latitude: array[0], longitude: array[1] };
}
exports.objectFromCoordinatesArray = objectFromCoordinatesArray;
function coordinatesArrayBounded(coordinates) {
    const [latitude, longitude] = coordinates;
    const boundedLatitude = Math.min(Math.max(latitude, 0), 90);
    const boundedLongitude = longitude > 180 ? longitude - 360 : longitude < -180 ? longitude + 360 : longitude;
    return [boundedLatitude, boundedLongitude];
}
exports.coordinatesArrayBounded = coordinatesArrayBounded;
